import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=4a3f8d30&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=ts&"
export * from "./banner.vue?vue&type=script&lang=ts&"
import style0 from "./banner.vue?vue&type=style&index=0&id=4a3f8d30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3f8d30",
  null
  
)

export default component.exports